import { AnyAction } from 'redux';
import { RAMP_SERVICES_GET } from './ramp-services.actions';
import { RampService } from '../model/types';

type RampServicesState = {
  list: RampService[];
};

const initialState: RampServicesState = {
  list: [],
};

const rampServicesReducer = (state: RampServicesState = initialState, action: AnyAction): RampServicesState => {
  switch (action.type) {
    case RAMP_SERVICES_GET:
      return {
        ...state,
        list: action.payload.services,
      };

    default:
      return state;
  }
};

export default rampServicesReducer;